import { NavigationExtras } from '@angular/router';
import { Action } from '@ngrx/store';

export const GO = '[Router-Auth] Go';
export const GO_TO_URL = '[Router-Auth] Go To URL';
export const BACK = '[Router-Auth] Back';
export const FORWARD = '[Router-Auth] Forward';

export class Go implements Action {
  readonly type = GO;

  constructor(public payload: {
    path: any[];
    query?: object;
    extras?: NavigationExtras;
  }) {}
}

export class GoToUrl implements Action {
  readonly type = GO_TO_URL;

  constructor(public payload: {
    url: string;
    extras?: NavigationExtras;
  }) {}
}

export class Back implements Action {
  readonly type = BACK;
}

export class Forward implements Action {
  readonly type = FORWARD;
}

export type Actions
  = Go
  | GoToUrl
  | Back
  | Forward;
